import React, { Component } from "react";
import { connect } from "react-redux";
import { call, put, select, takeEvery } from "redux-saga/effects";

import { LARGE_DEVICE_MIN_WIDTH } from "../util.js";
import { apiFetch } from "../sagas.js";

class Suggestions extends Component {
  render() {
    const universities = this.props.data.universities;
    const uniOptions = [<option key={-1} value={""} />];
    for (var i in universities) {
      uniOptions.push(
        <option key={i} value={i}>
          {universities[i]}
        </option>
      );
    }

    const departments = this.props.data.departments[this.props.universityId];
    const depsOptions = [<option key={-1} value={""} />];
    for (let i in departments) {
      depsOptions.push(
        <option key={i} value={i}>
          {departments[i]}
        </option>
      );
    }

    const canSubmit =
      this.props.firstName.length > 0 &&
      this.props.lastName.length > 0 &&
      this.props.universityId !== "" &&
      this.props.departmentId !== "";
    return (
      <div id="Suggestions" className="container padded page">
        <h2 className="page-header text-center">Sugiere un Profe</h2>
        <div className="row padded">
          <form className="offset-md-3 col-md-6" onSubmit={this.props.onSubmit}>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="firstName">Nombre</label>
                <input
                  autoFocus={window.innerWidth > LARGE_DEVICE_MIN_WIDTH}
                  value={this.props.firstName}
                  onChange={this.props.onFirstNameChange}
                  type="text"
                  className="form-control form-control-lg"
                  id="firstName"
                  placeholder="Nombre"
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="lastName">Apellido</label>
                <input
                  ref={input => (this.lastNameInput = input)}
                  value={this.props.lastName}
                  onChange={this.props.onLastNameChange}
                  type="text"
                  className="form-control form-control-lg"
                  id="lastName"
                  placeholder="Apellido"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="universitySelect">Universidad</label>
                <select
                  id="universitySelect"
                  className="form-control form-control-lg"
                  value={this.props.universityId}
                  onChange={event => this.props.onUniversityChange(event)}
                >
                  {uniOptions}
                </select>
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="departmentSelect">Departamento</label>
                <select
                  id="departmentSelect"
                  className="form-control form-control-lg"
                  value={this.props.departmentId}
                  onChange={event => this.props.onDepartmentChange(event)}
                >
                  {depsOptions}
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="col-md-12">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg btn-block"
                  disabled={!canSubmit}
                >
                  Sugerir Profe
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.suggestions,
    data: state.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFirstNameChange: event => {
      dispatch({ type: CHANGE_FIRST_NAME, value: event.target.value });
    },
    onLastNameChange: event => {
      dispatch({ type: CHANGE_LAST_NAME, value: event.target.value });
    },
    onUniversityChange: event => {
      const v = parseInt(event.target.value, 10);
      dispatch({ type: CHANGE_UNIVERSITY, value: isNaN(v) ? "" : v });
    },
    onDepartmentChange: event => {
      const v = parseInt(event.target.value, 10);
      dispatch({ type: CHANGE_DEPARTMENT, value: isNaN(v) ? "" : v });
    },
    onSubmit: event => {
      event.preventDefault();
      dispatch({ type: SUBMIT_SUGGESTION_REQUESTED });
    }
  };
};

const SuggestionsContainer = connect(mapStateToProps, mapDispatchToProps)(
  Suggestions
);

// ===== ACTIONS
const CHANGE_FIRST_NAME = "SUGGESTION_CHANGE_FIRST_NAME";
const CHANGE_LAST_NAME = "SUGGESTION_CHANGE_LAST_NAME";
const CHANGE_UNIVERSITY = "SUGGESTION_CHANGE_UNIVERSITY";
const CHANGE_DEPARTMENT = "SUGGESTION_CHANGE_DEPARTMENT";
const SUBMIT_SUGGESTION_REQUESTED = "SUBMIT_SUGGESTION_REQUESTED";
export const SUBMIT_SUGGESTION_SUCCEEDED = "SUBMIT_SUGGESTION_SUCCEEDED";
const SUBMIT_SUGGESTION_FAILED = "SUBMIT_SUGGESTION_FAILED";

// ===== SAGAS
const submitSuggestion = function*() {
  try {
    const { firstName, lastName, universityId, departmentId } = yield select(
      state => state.suggestions
    );
    const json = yield call(
      apiFetch("POST", { firstName, lastName, universityId, departmentId }),
      "/api/suggestions"
    );
    yield put({ type: SUBMIT_SUGGESTION_SUCCEEDED, data: json });
  } catch (e) {
    yield put({ type: SUBMIT_SUGGESTION_FAILED });
  }
};
const suggestionsSaga = takeEvery(
  SUBMIT_SUGGESTION_REQUESTED,
  submitSuggestion
);

// ===== REDUCER
const initialState = {
  firstName: "",
  lastName: "",
  universityId: "",
  departmentId: ""
};

const SuggestionsReducer = function(state = initialState, action) {
  switch (action.type) {
    case CHANGE_FIRST_NAME:
      return {
        ...state,
        firstName: action.value
      };
    case CHANGE_LAST_NAME:
      return {
        ...state,
        lastName: action.value
      };
    case CHANGE_UNIVERSITY:
      return {
        ...state,
        universityId: action.value,
        departmentId: ""
      };
    case CHANGE_DEPARTMENT:
      return {
        ...state,
        departmentId: action.value
      };
    case SUBMIT_SUGGESTION_SUCCEEDED:
      return {
        ...state,
        firstName: "",
        lastName: "",
        universityId: "",
        departmentId: ""
      };
    default:
      return state;
  }
};

export { suggestionsSaga, SuggestionsReducer };

export default SuggestionsContainer;



// WEBPACK FOOTER //
// ./src/containers/SuggestionsContainer.js